import { render } from "./VehicleGroupList.vue?vue&type=template&id=393454d2&scoped=true"
import script from "./VehicleGroupList.vue?vue&type=script&lang=js"
export * from "./VehicleGroupList.vue?vue&type=script&lang=js"

import "./VehicleGroupList.vue?vue&type=style&index=0&id=393454d2&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393454d2"]])

export default __exports__